import React from 'react';
import type { BrandConfig } from '@lds-efsp/brand-config';

interface PriorityConfig {
  label: string;
  bg: string;
  text: string;
}

type PriorityLevel = 'standard' | 'priority' | 'urgent' | 'on-demand';

const PRIORITY_CONFIG: Record<PriorityLevel, PriorityConfig> = {
  'standard': {
    label: 'Standard',
    bg: '#ECFDF5',
    text: '#0F9D6B',
  },
  'priority': {
    label: 'Priority',
    bg: '#FEF3C7',
    text: '#D97706',
  },
  'urgent': {
    label: 'Urgent',
    bg: '#FEE2E2',
    text: '#DC2626',
  },
  'on-demand': {
    label: 'On-Demand',
    bg: '#EFF6FF',
    text: '#3A6BCE',
  },
};

interface PriorityBadgeProps {
  priority: string;
  brand?: BrandConfig;
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  const config = PRIORITY_CONFIG[priority as PriorityLevel] || PRIORITY_CONFIG['standard'];

  return (
    <span
      className="inline-flex px-2 py-0.5 text-xs font-medium rounded-sm"
      style={{
        backgroundColor: config.bg,
        color: config.text,
      }}
    >
      {config.label}
    </span>
  );
};
